module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__santander_White.01369bac.svg";